import { Api as api } from "../api";
const prefix = "/config";
// const prefix = "";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    tripCalculatorServiceV1CalculateTrip: build.mutation<
      TripCalculatorServiceV1CalculateTripApiResponse,
      TripCalculatorServiceV1CalculateTripApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/calculate-trip`,
        method: "POST",
        body: queryArg.tripCalculatorV1CalculateTripReq,
      }),
    }),
    tripCalculatorServiceV1GetTripDistance: build.mutation<
      TripCalculatorServiceV1GetTripDistanceApiResponse,
      TripCalculatorServiceV1GetTripDistanceApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/trip-calculator/distance`,
        method: "POST",
        body: queryArg.tripCalculatorV1GetTripDistanceReq,
      }),
    }),
    tripCalculatorServiceV1GetPlacesAutocomplete: build.query<
      TripCalculatorServiceV1GetPlacesAutocompleteApiResponse,
      TripCalculatorServiceV1GetPlacesAutocompleteApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/trip-calculator/places/autocomplete`,
        params: {
          query: queryArg.query,
        },
      }),
    }),
    tripCalculatorServiceV1GetTripCalculatorTripTypes: build.query<
      TripCalculatorServiceV1GetTripCalculatorTripTypesApiResponse,
      TripCalculatorServiceV1GetTripCalculatorTripTypesApiArg
    >({
      query: () => ({ url: `${prefix}/v1/trip-calculator/trip-types` }),
    }),
    tripCalculatorServiceV1GetTripCalculatorVehicleModels: build.query<
      TripCalculatorServiceV1GetTripCalculatorVehicleModelsApiResponse,
      TripCalculatorServiceV1GetTripCalculatorVehicleModelsApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/trip-calculator/vehicle-models`,
        params: {
          vehicle_type_id: queryArg.vehicleTypeId,
        },
      }),
    }),
    tripCalculatorServiceV1GetTripCalculatorVehicleTypes: build.query<
      TripCalculatorServiceV1GetTripCalculatorVehicleTypesApiResponse,
      TripCalculatorServiceV1GetTripCalculatorVehicleTypesApiArg
    >({
      query: () => ({ url: `${prefix}/v1/trip-calculator/vehicle-types` }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as tripCalculatorApi };
export type TripCalculatorServiceV1CalculateTripApiResponse =
  /** status 200 A successful response. */ TripCalculatorV1CalculateTripRes;
export type TripCalculatorServiceV1CalculateTripApiArg = {
  tripCalculatorV1CalculateTripReq: TripCalculatorV1CalculateTripReq;
};
export type TripCalculatorServiceV1GetTripDistanceApiResponse =
  /** status 200 A successful response. */ TripCalculatorV1GetTripDistanceRes;
export type TripCalculatorServiceV1GetTripDistanceApiArg = {
  tripCalculatorV1GetTripDistanceReq: TripCalculatorV1GetTripDistanceReq;
};
export type TripCalculatorServiceV1GetPlacesAutocompleteApiResponse =
  /** status 200 A successful response. */ TripCalculatorV1GetPlacesAutocompleteRes;
export type TripCalculatorServiceV1GetPlacesAutocompleteApiArg = {
  query: string;
};
export type TripCalculatorServiceV1GetTripCalculatorTripTypesApiResponse =
  /** status 200 A successful response. */ TripCalculatorV1GetTripCalculatorTripTypesRes;
export type TripCalculatorServiceV1GetTripCalculatorTripTypesApiArg = void;
export type TripCalculatorServiceV1GetTripCalculatorVehicleModelsApiResponse =
  /** status 200 A successful response. */ TripCalculatorV1GetTripCalculatorVehicleModelsRes;
export type TripCalculatorServiceV1GetTripCalculatorVehicleModelsApiArg = {
  vehicleTypeId?: string;
};
export type TripCalculatorServiceV1GetTripCalculatorVehicleTypesApiResponse =
  /** status 200 A successful response. */ TripCalculatorV1GetTripCalculatorVehicleTypesRes;
export type TripCalculatorServiceV1GetTripCalculatorVehicleTypesApiArg = void;
export type TripCalculatorV1TripRefItem = {
  id?: string;
  name?: string;
};
export type TripCalculatorV1TripTypeRefItem = {
  id?: string;
  name?: string;
  value?: string;
};
export type TripCalculatorV1TripSegmentLocationRes = {
  id?: string;
  startLocationName?: string;
  startLocationLat?: number;
  startLocationLng?: number;
  endLocationName?: string;
  endLocationLat?: number;
  endLocationLng?: number;
  avoidToll?: boolean;
  distanceKm?: number;
  estimatedTimeMinutes?: number;
  routePolyline?: string;
};
export type TripCalculatorV1AdditionalCostRes = {
  id?: string;
  costType?: string;
  amount?: number;
  createdAt?: string;
};
export type TripCalculatorV1TripSegmentRes = {
  id?: string;
  segmentOrder?: number;
  tripType?: TripCalculatorV1TripTypeRefItem;
  locations?: TripCalculatorV1TripSegmentLocationRes[];
  distanceKm?: number;
  estimatedTimeMinutes?: number;
  recommendedTimeMinutes?: number;
  fuelUsage?: number;
  fuelPrice?: number;
  avgSpeed?: number;
  workingHours?: number;
  tripDays?: number;
  totalBasicRate?: number;
  incentiveRate?: number;
  solarPerjalanan?: number;
  totalFreezerFuel?: number;
  freezerFuelEfficiency?: number;
  expectedFuelCost?: number;
  driverBasicRate?: number;
  driverInsentifRate?: number;
  driverAllowance?: number;
  restTime?: number;
  idleTime?: number;
  freezerIdleHours?: number;
  additionalCosts?: TripCalculatorV1AdditionalCostRes[];
  segmentTotal?: number;
  createdAt?: string;
};
export type TripCalculatorV1CalculateTripData = {
  id?: string;
  customer?: string;
  temperature?: number;
  plateNumber?: string;
  vehicleType?: TripCalculatorV1TripRefItem;
  vehicleModel?: TripCalculatorV1TripRefItem;
  vehicleAttachments?: TripCalculatorV1TripRefItem[];
  segments?: TripCalculatorV1TripSegmentRes[];
  grandTotal?: number;
  status?: string;
  createdAt?: string;
  createdBy?: string;
};
export type TripCalculatorV1CalculateTripRes = {
  data?: TripCalculatorV1CalculateTripData;
};
export type ProtobufAny = {
  "@type"?: string;
  [key: string]: any;
};
export type RpcStatus = {
  code?: number;
  message?: string;
  details?: ProtobufAny[];
};
export type TripCalculatorV1LocationInput = {
  name: string;
  lat: number;
  lng: number;
  avoidToll?: boolean;
};
export type TripCalculatorV1RoutePair = {
  distanceKm?: number;
  estimatedTimeMinutes?: number;
  routePolyline?: string;
};
export type TripCalculatorV1AdditionalCostInput = {
  costType: string;
  amount: number;
};
export type TripCalculatorV1TripSegmentInput = {
  segmentOrder: number;
  tripTypeId: string;
  freezerIdleHours?: number;
  restTime?: number;
  distanceKm: number;
  estimatedTimeMinutes: number;
  locations: TripCalculatorV1LocationInput[];
  routePairs?: TripCalculatorV1RoutePair[];
  additionalCosts?: TripCalculatorV1AdditionalCostInput[];
};
export type TripCalculatorV1CalculateTripReq = {
  customer: string;
  temperature: number;
  plateNumber: string;
  vehicleTypeId: string;
  vehicleModelId: string;
  vehicleAttachmentIds?: string[];
  segments: TripCalculatorV1TripSegmentInput[];
};
export type TripCalculatorV1GetTripDistanceRes = {
  distanceKm?: number;
  estimatedTimeMinutes?: number;
  polyline?: string;
};
export type TripCalculatorV1GetTripDistanceReq = {
  originLat: number;
  originLng: number;
  destLat: number;
  destLng: number;
  avoidTolls?: boolean;
};
export type TripCalculatorV1PlacePrediction = {
  placeId?: string;
  description?: string;
  lat?: number;
  lng?: number;
};
export type TripCalculatorV1GetPlacesAutocompleteRes = {
  predictions?: TripCalculatorV1PlacePrediction[];
};
export type TripCalculatorV1GetTripCalculatorTripTypesRes = {
  tripTypes?: TripCalculatorV1TripRefItem[];
};
export type TripCalculatorV1GetTripCalculatorVehicleModelsRes = {
  vehicleModels?: TripCalculatorV1TripRefItem[];
};
export type TripCalculatorV1GetTripCalculatorVehicleTypesRes = {
  vehicleTypes?: TripCalculatorV1TripRefItem[];
};
export const {
  useTripCalculatorServiceV1CalculateTripMutation,
  useTripCalculatorServiceV1GetTripDistanceMutation,
  useTripCalculatorServiceV1GetPlacesAutocompleteQuery,
  useTripCalculatorServiceV1GetTripCalculatorTripTypesQuery,
  useTripCalculatorServiceV1GetTripCalculatorVehicleModelsQuery,
  useTripCalculatorServiceV1GetTripCalculatorVehicleTypesQuery,
} = injectedRtkApi;
